import {sizeNavbar} from './navbar_functions'
import FastClick from 'fastclick'

const closeNavbar = () => {
  const navCollapse = document.querySelector('#navbarSupportedContent')
  const toggler = document.querySelector('.navbar-toggler')

  if (navCollapse) {
    navCollapse.classList.remove('show')
    navCollapse.classList.add('collapse')
    navCollapse.setAttribute('aria-expanded', 'false')
    navCollapse.classList.remove('scroll-lock')
  }

  if (toggler) {
    toggler.classList.add('collapsed')
    toggler.setAttribute('aria-expanded', 'false')
  }

  if (document.body) {
    document.body.classList.remove('scroll-lock')
  }

  const middleNav = document.querySelector('.middle-nav')
  if (middleNav) {
    middleNav.classList.remove('show')
  }

  document.querySelectorAll('.child-expanded').forEach(element => {
    element.classList.remove('child-expanded')
  })

  const backdrop = document.querySelector('.navbar-backdrop')
  if (backdrop && backdrop.parentNode) {
    backdrop.parentNode.removeChild(backdrop)
  }

  document.querySelectorAll('.offcanvas-backdrop, .modal-backdrop').forEach(element => {
    if (element.parentNode) {
      element.parentNode.removeChild(element)
    }
  })
}

document.addEventListener('turbo:before-visit', closeNavbar)
document.addEventListener('turbo:load', () => {
  closeNavbar()
  const language = document.getElementsByClassName('icon-language')[0]
  const account = document.getElementsByClassName('icon-account')[0]
  const phone = document.getElementsByClassName('icon-phone')[0]
  const search = document.getElementsByClassName('icon-search')[0]
  const subnavDropdowns = document.getElementsByClassName('navbar-dropdown')
  const subnavBack = document.getElementsByClassName('subnav-back')[0]
  const accountSubnavBack = document.getElementsByClassName('account-subnav-back')[0]
  const secondMenus = document.getElementsByClassName('secondary-menu')
  const menus = document.querySelectorAll('.navbar-dropdown')
  const phoneDropdown = document.querySelector('.phone-number span')
  const searchDropdown = document.getElementsByClassName('search-box')[0]
  const languageDropdown = document.getElementsByClassName('language-menu')[0]
  const accountDropdown = document.getElementsByClassName('account-box')[0]
  const originals = document.getElementsByClassName('original')
  const accountIcon = document.querySelector('.account-icon')
  const navItems = document.getElementsByClassName('original navbar-item')
  const back = document.getElementById('account-back-container')
  const navLinks = document.getElementsByClassName('nav-link')
  const backIcon = document.querySelector('.secondary-menu .back-icon')
  const contact = document.getElementsByClassName('contact-us')
  const navbarItems = document.getElementsByClassName('navbar-item')
  const navLabels = document.getElementsByClassName('nav-label')
  const mobileAccount = document.getElementsByClassName('mobile-account')
  const middleNav = document.querySelector('.middle-nav')
  const navbarToggler = document.querySelector('.navbar-toggler')
  const phoneMenu = document.querySelector('.phone-menu')
  const navbarTranslate = document.querySelector('.navbar-translate')
  const phoneContact = document.querySelector('.menu-item.phone-contact')

  const isDerby = () => window.name == 'derby'
  const supercars = () => window.name == 'supercars'
  const sglmg = () => window.name == 'sglmg'
  const atp = () => window.name == 'atp'
  const isF1ausgp = () => window.name == 'f1ausgp'
  const isMotoausgp = () => window.name == 'motoausgp'
  const isBarca = () => window.name == 'barca'
  const isBarrett = () => window.name == 'barrett'
  const isRWC = () => window.name == 'rwc'
  const isMobile = () => window.innerWidth < 992

  let navbarHeight = undefined

  const isCollapsible = () => {
    if(isDerby()) {
      return true
    } else {
      return $('main').height() > $(window).height()
    }
  }
  
  function updateCollapse() {
    if (!isCollapsible()) { return }
  
    const body = $('body')
    const collapsed = body.hasClass('navbar-collapsed')
    const toggle = (collapsed && (window.pageYOffset < navbarHeight)) ||
      (!collapsed && (window.pageYOffset >= navbarHeight))

    if (toggle) { body.toggleClass('navbar-collapsed') }
    sizeNavbar()
  }

  if (typeof FastClick !== 'undefined') {
    FastClick.attach(document.body)
  }

  if (document.querySelector('.navbar').offsetParent !== null) {
    navbarHeight = document.querySelector('.navbar').offsetHeight
  }
  

  document.addEventListener('scroll', updateCollapse)


  if(accountSubnavBack) {
    accountSubnavBack.addEventListener('click', () => {
      if(!supercars() && !sglmg() && !isF1ausgp() && !isMotoausgp()) {
        Array.from(subnavDropdowns).forEach(subnavDropdown => {
          subnavDropdown.classList.toggle('child-expanded')
        })

        Array.from(navItems).forEach(navItem => {
          navItem.classList.toggle('child-expanded')
        })

        Array.from(navLinks).forEach(navLink => {
          navLink.classList.toggle('child-expanded')
        })

        if(isBarca() || isBarrett()) {
          phoneContact.classList.toggle('d-none')
        }
      }
    }
    )}
  
  if(accountIcon) {
    accountIcon.addEventListener('click', () => {
      if((!supercars() && !sglmg() && !isF1ausgp() && !isMotoausgp()) && isMobile()) {
        Array.from(subnavDropdowns).forEach(subnavDropdown => {
          subnavDropdown.classList.toggle('child-expanded')
        })

        Array.from(navItems).forEach(navItem => {
          navItem.classList.toggle('child-expanded')
        })
  
        Array.from(navLinks).forEach(navLink => {
          navLink.classList.toggle('child-expanded')
        })

        if(isBarca() || isBarrett()) {
          phoneContact.classList.toggle('d-none')
        }
      }
    })
  }

  if(backIcon) {
    backIcon.addEventListener('click', () => {
      Array.from(secondMenus).forEach(secondMenu => {
        secondMenu.classList.remove('show')
      })
    })
  }

  if(back) {
    back.addEventListener('click', () => {
      Array.from(subnavDropdowns).forEach(subnavDropdown => {
        subnavDropdown.classList.toggle('child-expanded')
      })

      Array.from(navItems).forEach(navItem => {
        navItem.classList.toggle('child-expanded')
      })

      Array.from(navLinks).forEach(navLink => {
        navLink.classList.toggle('child-expanded')
      })
    })
  }

  if(originals) {
    Array.from(originals).forEach(original => {
      original.addEventListener('click', (e) => {
        Array.from(secondMenus).forEach(secondMenu => {
          if(secondMenu !== e.target.parentNode.nextSibling) {
            secondMenu.classList.remove('show')
          }
          if(languageDropdown)
            languageDropdown.classList.remove('open')
        })
      })
    })
  }


  if (subnavDropdowns && menus && !atp() && !isF1ausgp() && !isMotoausgp() && !isBarca() && !isBarrett()) {
    if (window.innerWidth > 992) {
      Array.from(subnavDropdowns).forEach((subnavDropdown, index) => {
        const menu = menus[index]
        const uniqueClass = 'menu-' + index
        menu.classList.add(uniqueClass)
        subnavDropdown.addEventListener('mouseover', () => {
          const targetMenu = document.querySelector(`.${uniqueClass}`)
          targetMenu.classList.add('open')
          targetMenu.classList.remove('closed')
          if(accountDropdown) {
            accountDropdown.classList.remove('show')
          }
          if(phoneMenu) {
            phoneMenu.classList.remove('show')
          }
        })
        subnavDropdown.addEventListener('mouseout', (e) => {
          const relatedTarget = e.relatedTarget || e.toElement
          if (!subnavDropdown.contains(relatedTarget) && relatedTarget !== menu) {
            const targetMenu = document.querySelector(`.${uniqueClass}`)
            targetMenu.classList.remove('open')
            targetMenu.classList.add('closed')
            if(accountDropdown) {
              accountDropdown.classList.remove('show')
            }
            if(phoneMenu) {
              phoneMenu.classList.remove('show')
            }
          }
        })
      })
    }
  }

  if (subnavDropdowns && menus && (atp() || isF1ausgp() || isMotoausgp() || isBarca() || isBarrett())) {
    if (window.innerWidth > 992) {
      Array.from(subnavDropdowns).forEach((subnavDropdown, index) => {
        const menu = menus[index]
        const uniqueClass = 'menu-' + index
        menu.classList.add(uniqueClass)
        subnavDropdown.addEventListener('click', () => {
          const targetMenu = document.querySelector(`.${uniqueClass}`)
          targetMenu.classList.toggle('open')
          targetMenu.classList.toggle('closed')
          if (accountDropdown) {
            accountDropdown.classList.toggle('show')
          }
          if (phoneMenu) {
            phoneMenu.classList.toggle('show')
          }
        })
        subnavDropdown.addEventListener('click', (e) => {
          const relatedTarget = e.relatedTarget || e.toElement
          if (!subnavDropdown.contains(relatedTarget) && relatedTarget !== menu) {
            const targetMenu = document.querySelector(`.${uniqueClass}`)
            targetMenu.classList.toggle('open')
            targetMenu.classList.toggle('closed')
            if (accountDropdown) {
              accountDropdown.classList.toggle('show')
            }
            if (phoneMenu) {
              phoneMenu.classList.toggle('show')
            }
          }
        })
      })
    }
  }

  if(subnavBack && !isF1ausgp() && !isMotoausgp()) {
    subnavBack.addEventListener('click', (event) => {
      event.preventDefault()
    })
  }

  if(search) {
    search.addEventListener('click', () => {
      phoneDropdown.classList.remove('open')
      searchDropdown.classList.toggle('open')
      languageDropdown.classList.remove('open')
      if(accountDropdown) {
        accountDropdown.classList.remove('show')
      }
    })
  }

  if(phone) {
    phone.addEventListener('click', () => {
      phoneDropdown.classList.toggle('open')
      searchDropdown.classList.remove('open')
      if(languageDropdown)
        languageDropdown.classList.remove('open')
      if(accountDropdown) {
        accountDropdown.classList.remove('show')
      }
    })
  }

  if(language) {
    language.addEventListener('click', () => {
      phoneDropdown.classList.remove('open')
      searchDropdown.classList.remove('open')
      languageDropdown.classList.toggle('open')
      if(accountDropdown) {
        accountDropdown.classList.remove('show')
      }
      Array.from(secondMenus).forEach(secondMenu => {
        secondMenu.classList.remove('show')
      })
    })
  }
  
  if(account) {
    account.addEventListener('click', () => {
      phoneDropdown.classList.remove('open')
      searchDropdown.classList.remove('open')
      if(languageDropdown)
        languageDropdown.classList.remove('open')
      if(accountDropdown) {
        accountDropdown.classList.toggle('show')
      }
    })
  }

  
  if(subnavDropdowns && window.innerWidth < 992) {
    if(isF1ausgp() || isMotoausgp()) {
      Array.from(subnavDropdowns).forEach(subNavDropdown => {
        if(!supercars() && !sglmg()) {
          subNavDropdown.addEventListener('click', () => {
            let dropdownMenuWrapper = subNavDropdown.querySelector('.dropdown-menu-wrapper')
            if(dropdownMenuWrapper) {
              dropdownMenuWrapper.classList.toggle('active')
            }
            
          })
        }
      })
    } else {
      Array.from(subnavDropdowns).forEach(subNavDropdown => {
        if(!supercars() && !sglmg() && !isBarca() && !isBarrett()) {
          subNavDropdown.addEventListener('click', () => {
            Array.from(navLabels).forEach(navLabel => {
              navLabel.classList.toggle('d-none')
            })
            if(contact) {
              Array.from(contact).forEach(contact => {
                contact.classList.toggle('d-none')
              })
            } 
            Array.from(mobileAccount).forEach(mobileAccount => {
              mobileAccount.classList.toggle('d-none')
            })
            Array.from(navbarItems).forEach(navbarItem => {
              if(navbarItem.innerHTML === 'About Us') {
                navbarItem.classList.toggle('d-none')
              }
            })
            if(isBarca()) {
              phoneContact.classList.toggle('d-none')
            }
          })
        }
      })
    }
  }

  if(navbarToggler && window.innerWidth < 992) {
    navbarToggler.addEventListener('click', () => {
      setTimeout(() => { // Delaying the execution
        if(!middleNav.className.includes('show')) {
          Array.from(navLabels).forEach(navLabel => {
            navLabel.classList.remove('d-none')
          })
          if(contact) {
            Array.from(contact).forEach(contact => {
              contact.classList.remove('d-none')
            })
          } 
          Array.from(mobileAccount).forEach(mobileAccount => {
            mobileAccount.classList.remove('d-none')
          })
          Array.from(navbarItems).forEach(navbarItem => {
            if(navbarItem.innerHTML === 'About Us') {
              navbarItem.classList.remove('d-none')
            }
          })

          if(isBarca() || isBarrett()) {
            phoneContact.classList.remove('d-none')
          }
        }
      }, 500)
    })
  }

  if(navbarToggler && window.innerWidth < 992 && (isF1ausgp() || isMotoausgp())) {
    const closeBtn = document.querySelector('#navbarSupportedContent .btn-close')
    const headerWrapper = document.querySelector('.mobile-menu-header-wrapper')
    const contentWrapper = document.querySelector('.mobile-menu-content-wrapper')
    const navBars = document.querySelectorAll('.mobile-menu-header-wrapper a[aria-controls]')
    const subNavs = document.querySelectorAll('.mobile-menu-content-wrapper .mobile-dropdown-menu-wrapper')
    const subNavdropdownsBacks = document.querySelectorAll('.mobile-menu-content-wrapper .mobile-dropdown-menu-wrapper .subnav-back')


    if (closeBtn && navbarToggler) {
      closeBtn.addEventListener('click', function () {
        navbarToggler.click()

        headerWrapper.classList.remove('--hidden')
        contentWrapper.classList.add('--hidden')
        setTimeout(() => {
          navBars.forEach(function(navBar) {
            navBar.classList.remove('--show')
          })

          subNavs.forEach(function(subNav) {
            subNav.classList.remove('--show')
          })
        }, 500)
      })
    }

    navbarToggler.addEventListener('click', () => {
      if (navbarToggler.classList.contains('collapsed')) {
        document.body.classList.remove('scroll-lock')
        document.querySelector('#navbarSupportedContent').classList.remove('scroll-lock')
      } else {
        document.body.classList.add('scroll-lock')
        document.querySelector('#navbarSupportedContent').classList.add('scroll-lock')
      }
    })
    
    navBars.forEach(function (navBar) {
      navBar.addEventListener('click', function (e) {
        e.preventDefault()

        headerWrapper.classList.add('--hidden')
        contentWrapper.classList.remove('--hidden')

        const targetId = this.getAttribute('aria-controls')
        const targetDropdown = document.getElementById(targetId)

        if (targetDropdown) {
          targetDropdown.classList.add('--show')
        }
      })
    })


    subNavdropdownsBacks.forEach(function (backButton) {
      backButton.addEventListener('click', function (e) {
        e.preventDefault()

        headerWrapper.classList.remove('--hidden')
        contentWrapper.classList.add('--hidden')

        subNavs.forEach(function (subNav) {
          subNav.classList.remove('--show')
        })
      })
    })
  }

  if ((isF1ausgp() || isMotoausgp()) && window.innerWidth >= 992) {
    if (subnavDropdowns) {
      Array.from(subnavDropdowns).forEach((subNavDropdown) => {
        subNavDropdown.addEventListener('click', () => {
          let rightDropdownMenus = document.querySelectorAll('.right-nav .dropdown .dropdown-menu')
          rightDropdownMenus.forEach((rightDropdownMenu) => {
            rightDropdownMenu.classList.remove('show')
          })
        })
      })
    }
  }

  if((isF1ausgp() || isMotoausgp() || isBarca() || isBarrett()) && window.innerWidth >= 992) {
    document.addEventListener('click', (event) => {
      const isClickInside = event.target.closest('.right-nav .dropdown')
      if (!isClickInside) {
        let rightDropdownMenus = document.querySelectorAll('.right-nav .dropdown .dropdown-menu.show')
        rightDropdownMenus.forEach((rightDropdownMenu) => {
          if(languageDropdown) {
            languageDropdown.classList.remove('open')
          }
          rightDropdownMenu.classList.remove('show')
        })
      }
    })
  }

  if(isBarca() && window.innerWidth < 992) {
    if(navbarTranslate) {
      navbarTranslate.addEventListener('click', () => {
        if(navbarTranslate.classList.contains('show')) {
          navbarToggler.classList.add('collapsed')
          let navbarCollapse = document.querySelector('.navbar-collapse')
          if(navbarCollapse) {
            navbarCollapse.classList.remove('show')
          }
        }
      })

      navbarToggler.addEventListener('click', () => {
        navbarTranslate.classList.remove('show')
        languageDropdown.classList.remove('open')
        languageDropdown.classList.remove('show')
      })
    }
  }

  if(isBarca() || isBarrett()) {
    if(subnavDropdowns) {
      let navMobileItems = document.querySelectorAll('.menu-item.navbar-item.nav-item:not(.contact-us)')

      navMobileItems = Array.from(navMobileItems).filter(item => {
        return !item.closest('.dropdown-menu.secondary-menu')
      })

      Array.from(subnavDropdowns).forEach(subNavDropdown => {
        subNavDropdown.addEventListener('click', () => {
          if(isMobile()) {
            Array.from(navLabels).forEach(navLabel => {
              navLabel.classList.toggle('d-none')
            })
            if(contact) {
              Array.from(contact).forEach(contact => {
                contact.classList.toggle('d-none')
              })
            }
            if(navMobileItems.length > 0) {
              Array.from(navMobileItems).forEach(navItem => {
                navItem.classList.toggle('d-none')
              })
            }
            Array.from(mobileAccount).forEach(mobileAccount => {
              mobileAccount.classList.toggle('d-none')
            })
            Array.from(navbarItems).forEach(navbarItem => {
              if(navbarItem.innerHTML === 'About Us') {
                navbarItem.classList.toggle('d-none')
              }
            })
            phoneContact.classList.toggle('d-none')
          }
        })
      })
    }

    if(isMobile()) {
      navbarToggler.addEventListener('click', () => {
        setTimeout(() => {
          let navMobileItems = document.querySelectorAll('.menu-item.navbar-item.nav-item:not(.contact-us)')

          navMobileItems = Array.from(navMobileItems).filter(item => {
            return !item.closest('.dropdown-menu.secondary-menu')
          })

          Array.from(navLabels).forEach(navLabel => {
            navLabel.classList.remove('d-none')
          })
          if(contact) {
            Array.from(contact).forEach(contact => {
              contact.classList.remove('d-none')
            })
          }
          if(navMobileItems.length > 0) {
            Array.from(navMobileItems).forEach(navItem => {
              navItem.classList.remove('d-none')
            })
          }
          Array.from(mobileAccount).forEach(mobileAccount => {
            mobileAccount.classList.remove('d-none')
          })
          Array.from(navbarItems).forEach(navbarItem => {
            if(navbarItem.innerHTML === 'About Us') {
              navbarItem.classList.remove('d-none')
            }
          })
          phoneContact.classList.remove('d-none')

          Array.from(subnavDropdowns).forEach(subnavDropdown => {
            subnavDropdown.classList.remove('child-expanded')
          })
          Array.from(navItems).forEach(navItem => {
            navItem.classList.remove('child-expanded')
          })
          Array.from(navLinks).forEach(navLink => {
            navLink.classList.remove('child-expanded')
          })
        }, 300)
      })
    }
  }


  if (isRWC())  {
    setTimeout(() => {
      const nav = document.querySelector('ul.navbar-nav.navbar-nav-center a.d-none.d-lg-block')
      if (nav) nav.href = 'https://sportsnetholidays.com/'
    }, 300)
  }
})
